import type { ChangeEvent } from "react"

// stored as raw digits, formatted only at render:
// "66" + "911231234" → "+(66)91-123-1234"
export const PHONE_CODE_LENGTH = 2
export const PHONE_REST_DIGITS = [2, 3, 4] as const

export const isPhoneComplete = (code: string, rest: string) =>
    code.length === PHONE_CODE_LENGTH && rest.length === PHONE_REST_DIGITS.reduce((a, b) => a + b, 0)

export const formatPhoneRest = (digits: string) => {
    let out = digits.slice(0, PHONE_REST_DIGITS[0])
    let at = PHONE_REST_DIGITS[0]
    for (const n of PHONE_REST_DIGITS.slice(1)) {
        if (digits.length > at) out += "-" + digits.slice(at, at + n)
        at += n
    }
    return out
}

// deleting a separator leaves the digit count unchanged — drop the last
// digit instead, so backspace always removes a digit
export const maskPhoneChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    digits: string,
    maxLen: number
) => {
    const incoming = e.target.value
    const newDigits = incoming.replace(/\D/g, "")
    if (incoming.length < digits.length + 1 && newDigits === digits.slice(0, newDigits.length)) {
        // deletion — shrink by one digit
        return digits.slice(0, -1)
    }
    return newDigits.slice(0, maxLen)
}
